import React from 'react';
import styled from 'styled-components/macro';
import { theme } from 'styled-tools';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { SortableHandle } from 'react-sortable-hoc';

const DragIcon = styled(FontAwesomeIcon).attrs({
  icon: faBars,
})`
  cursor: pointer;
`;

const DragHandleWrapper = styled.div`
  background: ${theme('colors.lightTeal')};
  border-left: 1px solid ${theme('colors.mediumGray')};
  border-radius: 0 ${theme('borderRadius')} ${theme('borderRadius')} 0;
  display: flex;
  justify-content: center;

  ${DragIcon} {
    margin: 0.5em;
  }
`;

const DragHandle = SortableHandle(() => (
  <DragHandleWrapper>
    <DragIcon title='Drag Handle' />
  </DragHandleWrapper>
));

export default DragHandle;
